// Constants.
import * as Oauth2AuthorizeIftttConstants from 'constants/Oauth2AuthorizeIftttConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  url: '',
};

export default function oauth2AuthorizeIfttt(state = initialState, action = {}) {
  switch (action.type) {
    case Oauth2AuthorizeIftttConstants.LOAD_OAUTH2_AUTHORIZE_IFTTT_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case Oauth2AuthorizeIftttConstants.LOAD_OAUTH2_AUTHORIZE_IFTTT_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        url: action.url,
      };
    case Oauth2AuthorizeIftttConstants.LOAD_OAUTH2_AUTHORIZE_IFTTT_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        url: '',
        errorMessage: action.message,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        url: '',
        errorMessage: '',
      };
    default:
      return state;
  }
}
